import { EndpointQueryParameters } from '../../../types/strapi/strapi'
import { calculationPositionsQuery } from './calculation-positions-query'

export const defaultParams: EndpointQueryParameters = {
    populate: {
        calculation_positions: calculationPositionsQuery,
        client: {
            fields: ['documentId', 'name'],
        },
    },
    sort: ['createdAt:desc'],
}
